module.exports = __webpack_public_path__ + "static/media/a5-intro.54bc7342.png";